import axios from "axios";
import { Client } from "@/models/client.model";

class ClientService {
  /**
   * Pobiera listę klientów dla wszystkich dystrybutorów
   */
  async getClients(): Promise<Client[]> {
    const response = await axios.get<Client[]>("/client");
    return response.data;
  }

  /**
   * Pobiera listę klientów przypisanych do konkretnego dystrybutora
   * @param distributorId ID dystrybutora
   */
  async getClientsByDistributor(distributorId: string): Promise<Client[]> {
    const response = await axios.get<Client[]>(`/distributor/${distributorId}/clients`);
    return response.data;
  }

  /**
   * Pobiera szczegóły klienta po ID
   * @param id ID klienta
   */
  async getClientById(id: string): Promise<Client> {
    const response = await axios.get<Client>(`/client/${id}`);
    return response.data;
  }

  /**
   * Tworzy nowego klienta
   * @param client Dane nowego klienta
   */
  async createClient(client: Client): Promise<Client> {
    const response = await axios.post<Client>("/client", client);
    return response.data;
  }

  /**
   * Aktualizuje dane klienta
   * @param id ID klienta
   * @param client Dane do aktualizacji
   */
  async updateClient(id: string, client: Partial<Client>): Promise<Client> {
    const response = await axios.put<Client>(`/client/${id}`, client);
    return response.data;
  }

  /**
   * Usuwa klienta po ID
   * @param id ID klienta
   */
  async deleteClient(id: string): Promise<void> {
    await axios.delete(`/client/${id}`);
  }
}

export default new ClientService();
